import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-Mobile",
  "use": "svg-icon-Mobile-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"svg-icon-Mobile\"><path d=\"M2 14V0h12v16H2v-2zm2-2h8V2H4v10zm4 3a1 1 0 1 0 0-2 1 1 0 1 0 0 2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol